module.exports = __webpack_public_path__ + "static/media/BrownUs.e29d5e10.jpg";